'use client';

import type { CalendarProvider } from '@plura/shared/types';
import { cn, SCHEDULER_PROVIDER_LOGOS } from '@plura/shared/utils';
import Tooltip from '../Tooltip';

const PROVIDER_LABELS: Record<CalendarProvider, string> = {
  CALENDLY: 'Calendly',
  CALCOM: 'Cal.com',
  GOOGLE_CALENDAR: 'Google Calendar',
};

interface Props {
  providers: CalendarProvider[];
  className?: string;
  /** Logo mark size inside the 1:1 chip (default 18). */
  logoSize?: number;
}

const SchedulerProviderLogos = ({ providers, className, logoSize = 18 }: Props) => {
  return (
    <div className={cn('flex flex-wrap items-center gap-1.5', className)}>
      {providers.map((provider) => (
        <Tooltip
          key={provider}
          content={PROVIDER_LABELS[provider]}
          place="top"
          className="shrink-0 !cursor-default !opacity-100"
        >
          <div className="flex size-7 shrink-0 items-center justify-center overflow-hidden rounded-full bg-b-surface2">
            <img
              src={SCHEDULER_PROVIDER_LOGOS[provider]}
              alt={`${PROVIDER_LABELS[provider]} logo`}
              className="object-contain"
              style={{ maxHeight: logoSize, maxWidth: logoSize }}
            />
          </div>
        </Tooltip>
      ))}
    </div>
  );
};

export default SchedulerProviderLogos;
